import React from 'react';

interface VideoPlayIconProps {
  className?: string;
  background?: string;
  foreground?: string;
}

const VideoPlayIcon: React.FC<VideoPlayIconProps> = ({
  className,
  background = 'text-primary',
  foreground = 'text-white',
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="86"
    height="51"
    fill="none"
    viewBox="0 0 86 51"
  >
    <rect
      width="85.557"
      height="49.704"
      x="0.245"
      y="0.505"
      fill="#00B481"
      className={`fill-current ${background}`}
      rx="24.852"
    ></rect>
    <path
      className={`fill-current ${foreground}`}
      d="M48.769 24.878l-10.963-6.03a.547.547 0 00-.813.48v12.06a.547.547 0 00.813.48l10.963-6.03a.548.548 0 000-.96z"
    ></path>
  </svg>
);

export default VideoPlayIcon;
